import { Trans } from '@lingui/macro';
import { Form, Modal, Row } from 'antd';
import AuthActions from 'bukku/redux/Auth/actions';
import React, { useCallback, useRef } from 'react';
import Hotkeys from 'react-hot-keys';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppModalType } from '../../../enums/AppModalType';
import { StyledModal } from '../SessionInactiveModal/styles';
import ModalContent from './components/ModalContent';
import { useIdleObserver } from './hooks/useIdleObserver';
import { useModalInit } from './hooks/useModalInit';

const {
    logout,
    reauthenticate,
} = AuthActions;

const selectorFn = state => ({
    isIdleModalVisible: state.App.appModal[AppModalType.IDLE_MODAL].isVisible,
    isPushing: state.App.isPushing,
    user: state.User.user,
});

export default function SessionInactiveModalV2() {
    const dispatch = useDispatch();
    const {
        isIdleModalVisible,
        isPushing,
        user,
    } = useSelector(selectorFn, shallowEqual);

    const [form] = Form.useForm();
    const focusInputRef = useRef(null);

    // MAIN LOGIC -- Observer Pattern for Session Idle - 2 listeners
    // 1. Polling Timer
    // 2. Api Calls Listener useEffect
    useIdleObserver();

    // Initial - readUser, focus on input, reset Form
    useModalInit({user, focusInputRef, form, isIdleModalVisible});

    const handleOk = useCallback(() => {
        form.validateFields()
            .then(() => {
                const requestData = form.getFieldsValue();
                dispatch(reauthenticate(requestData));
            })
            .catch(() => {});
    }, [dispatch, form]);

    const handleCancel = () => {
        dispatch(logout());
        Modal.destroyAll(); // closes all modal such as lastVisited
    };

    return (
        <StyledModal
            visible={isIdleModalVisible}
            okText={<Trans>Resume Session</Trans>}
            okButtonProps={{
                loading: isPushing,
            }}
            cancelText={<Trans>Logout</Trans>}
            onOk={handleOk}
            onCancel={handleCancel}
            cancelButtonProps={{
                loading: isPushing,
            }}
            maskClosable={false}
            maskStyle={{
                backdropFilter: `blur(3px)`,
                WebkitBackdropFilter: `blur(3px)`,
            }}
            closable={false}
            keyboard={false}
            zIndex={1004}
        >
            <Row className="modal__session-inactive-row">
                <Hotkeys
                    keyName="enter"
                    onKeyDown={keyName => {
                        switch (keyName) {
                            case "enter":
                                handleOk();
                                return null;
                            default:
                                return null;
                        }
                    }}
                    filter={() => true} // to allow enter while focusing in input
                >
                    <ModalContent
                        form={form}
                        user={user}
                        focusInputRef={focusInputRef}
                    />
                </Hotkeys>
            </Row>
        </StyledModal>
    );
}
